/**
 * @name useSortingParams.js
 * @author 김권영
 * @since 2025. 01. 06.
 * @description
 * URL QueryString에 sortField / sortOrder를 저장하고,
 * 컬럼 클릭 시 정렬을 토글하는 로직을 제공하는 훅
 * 
 */
import { useSearchParams } from "react-router-dom";
export  function useSortingParams() {
  const [searchParams, setSearchParams] = useSearchParams();

  const sortField = searchParams.get("sortField") || "";
  const sortOrder = searchParams.get("sortOrder") || "ASC";

  const handleSortClick = (field) => {
    const newParams = new URLSearchParams(searchParams);

    if (sortField === field) {
      newParams.set("sortOrder", sortOrder === "ASC" ? "DESC" : "ASC");
    } else {
      newParams.set("sortField", field);
      newParams.set("sortOrder", "ASC");
    }

    newParams.set("pageIndex", "1");
    setSearchParams(newParams);
  };

  return { sortField, sortOrder, handleSortClick };
}
